export const REPORT_QUESTIONS_INFO = 'REPORT_QUESTIONS_INFO'
export const REPORT_QUESTIONS_INFO_SUCCESS = 'REPORT_QUESTIONS_INFO_SUCCESS'
export const REPORT_QUESTIONS_INFO_FAILED = 'REPORT_QUESTIONS_INFO_FAILED'
